var render = function() {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c(
    "div",
    { staticClass: "subpage-dashboards subpage-billing-payment--dashboard" },
    [
      _c(
        "h1",
        { staticClass: "my-account__title subpage-dashboards--left-spacer" },
        [_vm._v("Billing & Payment")]
      ),
      _vm._v(" "),
      _c(
        "div",
        {
          staticClass:
            "my-account__tab-nav gds-flex-container gds-flex-container--left"
        },
        [
          _c(
            "router-link",
            {
              staticClass: "my-account__tab-nav-item",
              attrs: { to: "/billing" }
            },
            [_vm._v("Overview")]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "my-account__tab-nav-item",
              attrs: { to: "/report" }
            },
            [_vm._v("Billing Report")]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "my-account__tab-nav-item",
              attrs: { to: "/preferences" }
            },
            [_vm._v("Billing Preferences")]
          ),
          _vm._v(" "),
          _c(
            "router-link",
            {
              staticClass: "my-account__tab-nav-item",
              attrs: { to: "/saved-payments" }
            },
            [_vm._v("Saved Payments")]
          )
        ],
        1
      ),
      _vm._v(" "),
      _c("router-view")
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }